<ng-container *ngIf="isLoadingOffers || isLoadingTags || tags.length">
  <ng-container *ngIf="isLoadingTags; else Tags">
    <div class="d-flex flex-nowrap overflow-scroll hide-scrollbar my-3" [ngClass]="{'mx-4': !isMobile}">
      <p-skeleton *ngFor="let i of [1,2,3,4,5]" borderRadius="16px" width="8rem" height="3rem" class="ms-3"></p-skeleton>
    </div>
  </ng-container>
  
  <ng-template #Tags>
    <div class="container-flex" [ngClass]="{'mt-5 mx-5': !isMobile, 'mt-3 mb-4': isMobile}">
      <p-tabMenu *ngIf="tags.length" [model]="tabMenuItems" [activeItem]="activeTag"
        (activeItemChange)="onTagSelection($event)">
      </p-tabMenu>
    </div>
  </ng-template>
  
  <div class="offers-container" [ngClass]="{'d-flex align-items-center': isLoadingTags || isLoadingOffers || !offers?.length}">
    <ng-container *ngIf="isLoadingTags || isLoadingOffers; else Offers">
      <div class="d-block w-100 mx-5">
        <app-card-loader [count]="2" [perLine]="isMobile ? 2 : 4"></app-card-loader>
      </div>
    </ng-container>
    <ng-template #Offers>
      <p-carousel *ngIf="tags?.length && offers?.length; else EmptyOffers" [showIndicators]="false" [value]="offers" class="tag-based-offers-carousel"
        [circular]="true" [numScroll]="1" [numVisible]="isMobile ? 2 : 4">
        <ng-template let-offer pTemplate="item">
          <app-offers-card [isMobile]="isMobile" class="d-flex offer-card" [offer]="offer" [clickPosition]="activeTag.code" [offerType]="categoryName" ></app-offers-card>
        </ng-template>
      </p-carousel>
    
      <ng-template #EmptyOffers>
        <div class="d-flex flex-column align-items-center justify-content-center">
          <pv-svg-icon name="empty_offers" class="empty_offers mt-4"></pv-svg-icon>
          <span class="mx-auto mt-3 mb-4">No Offers found!</span>
        </div>
      </ng-template>
    </ng-template>
  </div>
</ng-container>